module.exports = __webpack_public_path__ + "static/media/logo.940d016c.png";